/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

import { CIColors } from 'shared';

import settingsIcon from '../../../assets/images/settings_icon.svg';

export const createClustersListStyles = makeStyles(theme => ({
  root: {
    marginBottom: '14px',
    width: '100%',
    maxWidth: '800px',
  },
  editIcon: {
    cursor: 'pointer',
    width: '24px',
    height: '24px',
    mask: `url('${settingsIcon}')`,
    maskSize: '18px',
    maskPosition: 'center',
    maskRepeat: 'no-repeat',
    backgroundColor: theme.palette.graphicElements.main,
    '&:hover': {
      backgroundColor: CIColors.GraphicElementsHover,
    },
  },
  editColumn: {
    width: '20px',
    backgroundColor: '#FFFFFF',
    borderBottom: 'none',
  },
}));
